/**
 * Generates a callback to be called when info icon is pressed
 *
 * @param {object} params - Parameters
 * @param {function} params.showRecordPopover - A callback to show record popover
 * @param {function} params.recordsShowPopover - A callback to show popover
 * @param {function} params.reportShow - A callback to show record
 *
 * @returns {function} Callback - A function to be called when item is pressed
 */
import {ReportProps} from '../Report.types';

export function generateOnRecordPress({
  showRecordPopover = () => {},
  recordsShowPopover = () => {},
  recordsShowRecord = () => {},
}: ReportProps) {
  return ({id}: any) =>
    showRecordPopover([id], {recordsShowPopover, recordsShowRecord});
}
